import { Condition, ConditionComparison, ValueSource } from '../../models/Condition';
import { OutputViewModel } from '../../models/viewModels/OutputViewModel';
import { AGENT_FORWARD_TO_AGENT_STATE_STATUS } from './Actions';
import { CreateAgentStatus } from './Enums';
export const variableCondition = 'input.content@content.value.name';
export const variableConditionByType = 'input.content@content.value.type';
export const variableValueHandoff = 'application/vnd.iris.aiplatform.handoff+json';
export const variableConditionHandoff = 'input.content@content.type';
export const variableValueForward = 'outputForward';
export const conditionOutputAiAgents = [
    new OutputViewModel({
        $isAgentOutput: true,
        $isAgentCustomOutput: false,
        $isAgentDefaultOutput: true,
        conditions: [
            new Condition({
                source: ValueSource.Context,
                variable: AGENT_FORWARD_TO_AGENT_STATE_STATUS,
                comparison: ConditionComparison.Equals,
                values: [CreateAgentStatus.Error],
            }),
        ],
        stateId: 'fallback',
        $invalid: false,
    }),
];
